export default __webpack_public_path__ + "/dist/images/Buyer_page_it_AI.534582ea7f1bbf157ee0ea66c6aaf409.jpeg";